import React from 'react';
import { TabProps } from '../types';
import { Icon, Header, Grid } from 'semantic-ui-react';
import { DesignSystem } from '../../../styles/designSystem';

const BasicDataTab: React.FC<TabProps> = ({ data }) => {
  return (
    <div style={{
      padding: '1rem',
      background: DesignSystem.colors.section.gradient,
      minHeight: '30vh'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '1rem',
        boxShadow: '0 8px 15px rgba(0,0,0,0.08)',
        border: '1px solid rgba(255,255,255,0.8)'
      }}>
        <Header as="h2" style={{
          color: '#2c3e50',
          textAlign: 'center',
          marginBottom: '1rem',
          fontWeight: '700',
          fontSize: '1.3rem'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #3498db, #2980b9)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            <Icon name="building" size="large" />
            Dados Básicos da Empresa
          </div>
        </Header>

        <Grid columns={2} stackable>
          {[
            { label: 'CNPJ', value: data.cnpj, icon: 'id card' },
            { label: 'Razão Social', value: data.razaoSocial, icon: 'building outline' },
            { label: 'Nome Fantasia', value: data.nomeFantasia, icon: 'star' },
            { label: 'Tipo', value: data.tipo, icon: 'tag' },
            { label: 'Porte', value: data.porte, icon: 'chart bar' },
            { label: 'Data de Abertura', value: data.abertura, icon: 'calendar' },
            { label: 'Situação Cadastral', value: data.situacaoCadastral || data.situacao, icon: 'check circle' },
            { label: 'Natureza Jurídica', value: data.naturezaJuridica, icon: 'law' }
          ].map((item, index) => (
            <Grid.Column key={index}>
              <div style={{
                background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
                borderRadius: '8px',
                padding: '0.75rem',
                marginBottom: '0.5rem',
                boxShadow: '0 3px 8px rgba(0,0,0,0.04)',
                border: '1px solid rgba(52, 152, 219, 0.08)',
                transition: 'transform 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.08)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 3px 8px rgba(0,0,0,0.04)';
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #3498db, #2980b9)',
                    borderRadius: '50%',
                    padding: '0.3rem',
                    color: 'white',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Icon name={item.icon as any} size="tiny" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: '#7f8c8d',
                      fontSize: '0.7rem',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                      letterSpacing: '0.3px'
                    }}>
                      {item.label}
                    </div>
                    <div style={{
                      color: '#2c3e50',
                      fontSize: '0.9rem',
                      fontWeight: '500',
                      marginTop: '0.15rem'
                    }}>
                      {item.value || 'Não informado'}
                    </div>
                  </div>
                </div>
              </div>
            </Grid.Column>
          ))}
        </Grid>

        {data.capitalSocial && (
          <div style={{
            background: 'linear-gradient(135deg, #27ae60, #229954)',
            borderRadius: '10px',
            padding: '1rem',
            marginTop: '1rem',
            textAlign: 'center',
            color: 'white',
            boxShadow: '0 12px 25px rgba(39, 174, 96, 0.3)'
          }}>
            <Icon name="money bill alternate" />
            <Header as="h3" style={{ color: 'white', margin: '0.5rem 0', fontSize: '1.1rem' }}>
              Capital Social
            </Header>
            <div style={{
              fontSize: '1.4rem',
              fontWeight: '700',
              textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
            }}>
              R$ {data.capitalSocial.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BasicDataTab;
